module.exports = __webpack_public_path__ + "img/podcast.89c668ee.svg";